import { render } from "./AddAddressModal.vue?vue&type=template&id=5cdeb7ed&ts=true"
import script from "./AddAddressModal.vue?vue&type=script&lang=ts"
export * from "./AddAddressModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__